import { applicationLabel } from "@/lib/application";
import { sectorName } from "@/lib/resultsFr";
import { getLocale } from "@/lib/i18n";
import { num } from "@/lib/numfmt";

const fmt = (n) => num(n || 0, 1);

// The memo's one-line project summary under the title (Report and shared pages).
export const MemoMeta = ({ input, m, prio, country, t }) => {
  const head = getLocale() === "fr"
    ? [sectorName(input.sector), applicationLabel(input), country]
    : [input.sector, applicationLabel(input), input.country];
  return (
    <p className="mt-3" style={{ color: "var(--muted)" }} data-testid="memo-meta">
      {getLocale() === "fr"
        ? `${head.filter(Boolean).join(" · ")} · Pointe ${fmt(input.peak_kw)}\u00a0kW · Capacité ferme cible ${fmt(m.firm_capacity_target_kw)}\u00a0kW · `
          + `Priorité\u00a0: ${prio} · Mode de détention\u00a0: ${t(`wiz.own.${input.ownership}`, input.ownership)}`
        : `${head.filter(Boolean).join(" · ")} · Peak ${fmt(input.peak_kw)} kW · Firm target ${fmt(m.firm_capacity_target_kw)} kW · `
          + `Priority: ${prio} · Ownership: ${input.ownership}`}
    </p>
  );
};
